export default __webpack_public_path__ + "static/media/rick-flag.0bf66313.png";